<template>
  <Layout>
    <div v-if="showConfetti" class="confetti-overlay">
      <Vue3Lottie
          :animationData="confettiAnimation"
          :autoPlay="true"
          :loop="false"
          @onComplete="onConfettiComplete"
          ref="confettiRef"
      />
    </div>
      <h2 class="page-title">{{$t('billing_title')}}</h2>
    <div class="billing-container">
      <div class="left-section">
        <div class="current-plan-card">
          <span class="current-plan-title">{{$t('current_plan')}}</span>
          <div class="plan-header">
            <div class="plan-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4"
                      d="M11.5743 2.40305L7.66601 1.78638C4.40768 1.27805 2.89934 2.37805 2.38268 5.63638L1.76601 9.54471C1.43268 11.678 1.78268 13.0614 2.99101 13.903C3.62434 14.353 4.49101 14.653 5.61601 14.828L9.52434 15.4447C12.7827 15.953 14.291 14.853 14.8077 11.5947L15.416 7.68638C15.516 7.04471 15.5577 6.46971 15.5243 5.96138C15.416 3.87805 14.191 2.81138 11.5743 2.40305ZM6.86601 7.79471C5.89101 7.79471 5.09934 7.00305 5.09934 6.03638C5.09934 5.06138 5.89101 4.26971 6.86601 4.26971C7.83268 4.26971 8.62434 5.06138 8.62434 6.03638C8.62434 7.00305 7.83268 7.79471 6.86601 7.79471Z"
                      fill="#1C3CD5"/>
                <path
                    d="M17.0839 11.2257L15.8339 14.984C14.7922 18.1173 13.1255 18.9507 9.99219 17.909L6.23385 16.659C4.34219 16.034 3.29219 15.1673 2.99219 13.9007C3.62552 14.3507 4.49219 14.6507 5.61719 14.8257L9.52552 15.4423C12.7839 15.9507 14.2922 14.8507 14.8089 11.5923L15.4172 7.68398C15.5172 7.04232 15.5589 6.46732 15.5255 5.95898C17.5172 7.01732 17.9505 8.61732 17.0839 11.2257Z"
                    fill="#1C3CD5"/>
                <path
                    d="M8.62461 6.03034C8.62461 6.99701 7.83294 7.78867 6.86628 7.78867C5.89128 7.78867 5.09961 6.99701 5.09961 6.03034C5.09961 5.05534 5.89128 4.26367 6.86628 4.26367C7.83294 4.26367 8.62461 5.05534 8.62461 6.03034Z"
                    fill="#1C3CD5"/>
              </svg>
            </div>
            <div class="plan-info-wrapper">
              <div class="plan-info">
                <h3>{{ currentPlanInfo?.packageName || '--' }}</h3>
                <span class="user-count" v-if="currentPlanInfo?.totalUsers">({{ currentPlanInfo.totalUsers }} {{$t('user_title')}})</span>
              </div>

              <!--
              <div class="plan-info">
                <span>{{$t('remain_user')}}:</span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.4"
                        d="M6 6C7.38071 6 8.5 4.88071 8.5 3.5C8.5 2.11929 7.38071 1 6 1C4.61929 1 3.5 2.11929 3.5 3.5C3.5 4.88071 4.61929 6 6 6Z"
                        fill="#667085"/>
                  <path
                      d="M6.00008 7.25C3.49508 7.25 1.45508 8.93 1.45508 11C1.45508 11.14 1.56508 11.25 1.70508 11.25H10.2951C10.4351 11.25 10.5451 11.14 10.5451 11C10.5451 8.93 8.50508 7.25 6.00008 7.25Z"
                      fill="#667085"/>
                </svg>
                <span>{{ currentPlanInfo?.remainingUsers || '--' }} {{$t('users')}}</span>
              </div>-->

            </div>
          </div>

          <div class="progress-bar mb-2">
            <div class="progress-fill" :style="{ width: (currentPlanInfo?.usagePercentage || 0) + '%' }"></div>
          </div>

          <div class="plan-details">
            <p>{{ currentPlanInfo?.statusMessage || '--' }}</p>
          </div>

          <div class="plan-actions">
            <button class="btn-primary" @click="openPricingModal">{{$t('upgrading_plan')}}</button>
            <button class="btn-secondary" @click="openBillingModal">{{$t('manage_plan')}}</button>
          </div>
        </div>

        <div class="payment-method-card">
          <div class="payment-header">
            <h4>{{$t('payment_method')}}</h4>
            <button class="btn-outline" @click="openBillingModal">{{$t('edit')}}</button>
          </div>

          <div class="payment-info">
            <div class="card-info">
              <div class="card-wrapper">
                <div class="card-logo">
                  <svg v-if="!primaryCard" width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.09961" y="0.5" width="33" height="23" rx="3.5" fill="#f3f4f6"/>
                    <rect x="1.09961" y="0.5" width="33" height="23" rx="3.5" stroke="#d1d5db"/>
                    <text x="18" y="15" text-anchor="middle" fill="#9ca3af" font-size="8">{{$t('no_card')}}</text>
                  </svg>
                  <img v-else :src="'/card/'+primaryCard.cardBrand+'.svg'" alt="">
                </div>
                <div class="card-details">
                  <span class="card-brand">{{ getCardBrandName(primaryCard?.cardBrand) }}</span>
                  <span class="card-number">{{ primaryCard?.maskedCardNumber || '**** **** **** ****' }}</span>
                </div>
              </div>
              <div>
                <span class="expiry">{{$t('end_date')}}:
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M11 4.5V8.23C11 9.375 10.07 10.3 8.925 10.3H3.075C1.93 10.3 1 9.375 1 8.23V4.5H11Z" fill="#667085"/>
                    <path d="M11 3.76922V4.49922H1V3.76922C1 2.62422 1.93 1.69922 3.075 1.69922H8.925C10.07 1.69922 11 2.62422 11 3.76922Z" fill="#667085"/>
                    <path d="M4 8.625H3C2.795 8.625 2.625 8.455 2.625 8.25C2.625 8.045 2.795 7.875 3 7.875H4C4.205 7.875 4.375 8.045 4.375 8.25C4.375 8.455 4.205 8.625 4 8.625Z" fill="#667085"/>
                    <path d="M7.25 8.625H5.25C5.045 8.625 4.875 8.455 4.875 8.25C4.875 8.045 5.045 7.875 5.25 7.875H7.25C7.455 7.875 7.625 8.045 7.625 8.25C7.625 8.455 7.455 8.625 7.25 8.625Z" fill="#667085"/>
                  </svg>
                  {{ primaryCard ? `${String(primaryCard.expiryMonth).padStart(2, '0')}/${primaryCard.expiryYear}` : '--/--' }}
                </span>
              </div>
            </div>
          </div>

          <div class="next-payment">
            <img src="/src/assets/images/info.svg">
            <span>{{ currentPlanInfo?.firstPaymentMessage }}</span>
          </div>
        </div>

        <div class="transaction-history-card">
          <div class="transaction-header">
            <h4>{{$t('transaction_history')}}</h4>
            <button class="btn-outline" disabled>{{$t('export')}}</button>
          </div>

          <div class="transaction-table">
            <div class="table-header">
              <span>{{ $t('date') }}</span>
              <span>{{ $t('transaction_type') }}</span>
              <span>{{ $t('description') }}</span>
              <span>{{ $t('total_price') }}</span>
              <span>{{ $t('status') }}</span>
              <span>{{ $t('invoice_payment') }}</span>
            </div>

            <div v-if="isBillingLoading" class="no-data">
              <p class="no-data-found">{{ $t('loading') }}...</p>
            </div>

            <div v-else-if="billingHistory.length === 0" class="no-data">
              <p class="no-data-found">{{$t('no_data_found')}}</p>
            </div>

            <div v-else class="table-rows">
              <template v-for="inv in billingHistory" :key="inv.invoiceUuid || inv.orderId">
                <!-- Fatura satiri (ana) -->
                <div
                    class="table-row invoice-row is-expandable"
                    :class="{ expanded: expandedInvoices[inv.invoiceUuid || inv.orderId] }"
                    @click="toggleInvoice(inv)"
                >
                  <span class="row-date">{{ formatTransactionDate(inv.date) }}</span>
                  <span class="row-type">
                    <span :class="['type-badge', `type-${inv.type}`]">
                      {{ inv.type === 'addon' ? $t('transaction_type_addon') : $t('transaction_type_package') }}
                    </span>
                  </span>
                  <span class="row-description">
                    <span class="expand-icon">{{ expandedInvoices[inv.invoiceUuid || inv.orderId] ? '▾' : '▸' }}</span>
                    {{ inv.items?.length === 1 ? inv.items[0].description : ($t('invoice') + ' ' + (inv.invoiceNumber || '—') + ' (' + (inv.items?.length || 0) + ' ' + $t('items') + ')') }}
                  </span>
                  <span class="row-amount">
                    <strong>{{ inv.totalAmount.toFixed(2) }} {{ inv.currency }}</strong>
                    <small v-if="inv.tryEquivalent" class="try-equivalent">≈ {{ inv.tryEquivalent.totalAmount.toFixed(2) }} TRY</small>
                  </span>
                  <span class="row-status">
                    <span :class="['status-badge', `status-${inv.status || 'paid'}`]">
                      {{ inv.status === 'pending' ? $t('status_pending') : (inv.status === 'cancelled' ? $t('status_cancelled') : $t('status_paid')) }}
                    </span>
                  </span>
                  <span class="row-invoice" @click.stop>
                    <button v-if="inv.status === 'pending'" class="pay-now-btn" @click="handlePayPending(inv)">
                      {{ $t('pay_now') }}
                    </button>
                    <a v-else-if="inv.invoiceUrl" :href="inv.invoiceUrl" target="_blank" class="invoice-link">
                      {{ inv.invoiceNumber || $t('view_invoice') }}
                    </a>
                    <span v-else-if="inv.invoiceNumber" class="invoice-number">{{ inv.invoiceNumber }}</span>
                    <span v-else class="invoice-pending">—</span>
                  </span>
                </div>

                <!-- Kalemler (expand) -->
                <div v-if="expandedInvoices[inv.invoiceUuid || inv.orderId]" class="invoice-items">
                  <div v-for="item in inv.items" :key="item.id || item.description" class="invoice-line-item">
                    <span class="item-description">{{ item.description }}</span>
                    <span class="item-amount">
                      {{ item.amount.toFixed(2) }} {{ item.currency }}
                      <small v-if="item.tryEquivalent" class="try-equivalent">≈ {{ item.tryEquivalent.toFixed(2) }} TRY</small>
                    </span>
                  </div>
                  <div class="invoice-totals">
                    <div class="invoice-total-row">
                      <span>{{ $t('subtotal') || 'Ara toplam' }}</span>
                      <span>{{ inv.subtotal.toFixed(2) }} {{ inv.currency }}<small v-if="inv.tryEquivalent" class="try-equivalent">≈ {{ inv.tryEquivalent.subtotal.toFixed(2) }} TRY</small></span>
                    </div>
                    <div class="invoice-total-row">
                      <span>{{ $t('vat') || 'KDV' }} %{{ inv.vatRate }}</span>
                      <span>{{ inv.vatAmount.toFixed(2) }} {{ inv.currency }}<small v-if="inv.tryEquivalent" class="try-equivalent">≈ {{ inv.tryEquivalent.vatAmount.toFixed(2) }} TRY</small></span>
                    </div>
                    <div class="invoice-total-row total">
                      <span>{{ $t('total') || 'Toplam' }}</span>
                      <span><strong>{{ inv.totalAmount.toFixed(2) }} {{ inv.currency }}</strong><small v-if="inv.tryEquivalent" class="try-equivalent">≈ {{ inv.tryEquivalent.totalAmount.toFixed(2) }} TRY</small></span>
                    </div>
                    <div v-if="inv.exchangeRate" class="invoice-rate-note">
                      {{ $t('exchange_rate') || 'Kur' }}: 1 {{ inv.currency }} = {{ Number(inv.exchangeRate).toFixed(4) }} TRY
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

         <!-- <div class="billing-note">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7 13.25C10.4518 13.25 13.25 10.4518 13.25 7C13.25 3.54822 10.4518 0.75 7 0.75C3.54822 0.75 0.75 3.54822 0.75 7C0.75 10.4518 3.54822 13.25 7 13.25ZM8.11584 10.2086L8.21565 9.8006C8.16399 9.82486 8.0807 9.85258 7.96649 9.88414C7.85197 9.9157 7.7489 9.93177 7.65831 9.93177C7.46536 9.93177 7.32952 9.90014 7.25065 9.83657C7.17236 9.773 7.13331 9.65342 7.13331 9.47827C7.13331 9.40887 7.14509 9.30542 7.16973 9.17003C7.19361 9.03373 7.22108 8.91261 7.25161 8.80666L7.62419 7.48759C7.66068 7.36653 7.68571 7.23344 7.69916 7.08818C7.71292 6.94325 7.71932 6.84185 7.71932 6.78429C7.71932 6.50614 7.62182 6.28041 7.42676 6.10629C7.2317 5.93229 6.95393 5.84529 6.59396 5.84529C6.39365 5.84529 6.18188 5.88088 5.95776 5.952C5.73363 6.02294 5.49933 6.1084 5.25421 6.2082L5.15415 6.6165C5.22719 6.58949 5.31419 6.56043 5.41598 6.53034C5.51732 6.50038 5.61674 6.48489 5.71347 6.48489C5.91096 6.48489 6.04399 6.51856 6.1137 6.58488C6.18342 6.65139 6.21844 6.7697 6.21844 6.93883C6.21844 7.03236 6.20736 7.13626 6.18438 7.24919C6.16172 7.36282 6.13342 7.48298 6.10013 7.6098L5.72595 8.93419C5.69266 9.07336 5.66834 9.19787 5.65304 9.30843C5.63786 9.41886 5.63057 9.52724 5.63057 9.63262C5.63057 9.90482 5.73114 10.1292 5.93222 10.3063C6.13329 10.4826 6.41523 10.5714 6.77769 10.5714C7.01372 10.5714 7.22088 10.5406 7.39917 10.4785C7.57727 10.4167 7.81644 10.3268 8.11584 10.2086ZM8.04946 4.8502C8.22352 4.68882 8.31014 4.49254 8.31014 4.26272C8.31014 4.03341 8.22365 3.83675 8.04946 3.67331C7.87584 3.51032 7.66657 3.42857 7.4219 3.42857C7.17646 3.42857 6.96635 3.51013 6.79107 3.67331C6.61579 3.83675 6.52796 4.03334 6.52796 4.26272C6.52796 4.49254 6.61579 4.68875 6.79107 4.8502C6.96667 5.01217 7.17639 5.09321 7.4219 5.09321C7.66664 5.09321 7.87584 5.01217 8.04946 4.8502Z"
                    fill="#98A2B3"/>
            </svg>
            <span>{{ currentPlanInfo?.twoPaymentMessage }}</span>
          </div>-->
        </div>
      </div>

      <div class="right-section">
        <div class="usage-card">
          <div class="usage-card-header">
            <h4>{{ $t('remained_usages') }}</h4>
            <span v-if="!currentPlanInfo?.isDemo" class="addon-link" @click="$router.push('/billing/addons')">{{ $t('buy_addon_package') }}</span>
          </div>
          <div v-if="formattedRealUsageItems.length > 0">
            <div
                v-for="item in formattedRealUsageItems"
                :key="item.productKey"
                class="usage-item"
            >
              <div class="usage-header">
                <span class="usage-label">{{ item.displayName }}</span>
              </div>
              <div class="progress-bar">
                <div
                    class="progress-fill"
                    :style="{ width: item.usagePercentage + '%' }"
                    :class="{
              'progress-danger': item.usagePercentage > 90,
              'progress-warning': item.usagePercentage > 70 && item.usagePercentage <= 90,
              'progress-success': item.usagePercentage <= 70
            }"
                ></div>
              </div>
              <span class="usage-count" :class="{ 'usage-danger': item.usagePercentage > 90 }">
          {{ $t('remain_user') }}: {{ item.remainingLimit }}/{{ item.assignedLimit }} {{ item.unit }}
        </span>
            </div>
          </div>

          <div v-else-if="isUsageLoading">
            <div v-for="i in 6" :key="i" class="usage-item">
              <div class="usage-header">
                <span class="usage-label">{{ $t('loading') }}...</span>
              </div>
              <div class="progress-bar">
                <div class="progress-fill skeleton-loading"></div>
              </div>
              <span class="usage-count">--/-- --</span>
            </div>
          </div>

          <div v-else-if="usageError" class="usage-error">
            <p>{{ usageError }}</p>
            <button @click="loadUsageData" class="btn-retry">{{ $t('try_again') }}</button>
          </div>

          <div v-else class="usage-empty">
            <p>{{$t('no_usage_information_found')}}</p>
          </div>

          <button class="btn-manage" @click="openPackageManageModal">{{$t('manage')}}</button>
        </div>

        <!-- AI Kredi Kullanımı -->
        <div v-if="aiCreditData && aiCreditData.hasAccess" class="usage-card ai-credit-card">
          <div class="usage-card-header">
            <h4>{{ $t('ai_credit_title') }}</h4>
            <span class="addon-link" @click="$router.push('/billing/addons')">{{ $t('ai_credit_buy_more') }}</span>
          </div>

          <div class="ai-credit-summary">
            <div class="ai-credit-main">
              <div class="usage-header">
                <span class="usage-label">{{ $t('ai_credit_total_usage') }}</span>
              </div>
              <div class="progress-bar">
                <div
                    class="progress-fill"
                    :style="{ width: aiCreditUsagePercentage + '%' }"
                    :class="{
                      'progress-danger': aiCreditUsagePercentage > 90,
                      'progress-warning': aiCreditUsagePercentage > 70 && aiCreditUsagePercentage <= 90,
                      'progress-success': aiCreditUsagePercentage <= 70
                    }"
                ></div>
              </div>
              <span class="usage-count" :class="{ 'usage-danger': aiCreditUsagePercentage > 90 }">
                {{ $t('remain_user') }}: {{ aiCreditData.remaining }}/{{ aiCreditData.total }} {{ $t('ai_credit_unit') }}
              </span>
            </div>

            <div class="ai-credit-breakdown">
              <span class="ai-credit-breakdown-title">{{ $t('ai_credit_breakdown_label') }}</span>
              <div class="ai-credit-detail-row">
                <span>{{ $t('ai_credit_base') }}</span>
                <span>{{ aiCreditData.baseLimit }} {{ $t('ai_credit_unit') }}</span>
              </div>
              <div class="ai-credit-detail-row">
                <span>{{ $t('ai_credit_additional') }}</span>
                <span>{{ aiCreditData.additionalLimit }} {{ $t('ai_credit_unit') }}</span>
              </div>
            </div>

            <div v-if="aiCreditData.agents && aiCreditData.agents.length > 0" class="ai-credit-agents">
              <span class="ai-credit-breakdown-title">{{ $t('ai_credit_agent_usage') }}</span>
              <div
                  v-for="agent in aiCreditData.agents"
                  :key="agent.aiAgentId"
                  class="ai-credit-detail-row"
              >
                <span>{{ agent.aiAgentId }}</span>
                <span>{{ agent.usedCredits }} {{ $t('ai_credit_unit') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PricingPacketModal
        :isVisible="showPricingModal"
        :packages="packages"
        :userPackageStatus="enhancedUserPackageStatus"
        :urgency="bannerUrgency"
        :paymentMethods="paymentMethods"
        :billingHistory="billingHistory"
        @close="showPricingModal = false"
        @package-upgraded="onPackageUpgraded"
    />

    <PricingManagementModal
        :is-visible="isBillingModalOpen"
        @close="closeBillingModal"
        @billing-updated="onBillingUpdated"
        @add-card="onAddCard"
        @delete-card="onDeleteCard"
        @card-primary-changed="onCardPrimaryChanged"
    />

    <PackageManageModal
        :is-visible="showPackageManageModal"
        :package-status="packageManageData"
        :is-loading="isPackageManageLoading"
        @close="showPackageManageModal = false"
        @upgrade-clicked="openPricingModal"
    />

  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import PricingPacketModal from "../components/modals/PricingPacketModal.vue";
import PricingManagementModal from "@/components/modals/PricingManagementModal.vue";
import PackageManageModal from "@/components/modals/PackageManageModal.vue";
import aiAgentService from "@/service/aiAgentService";
import {useCartStore} from "@/stores/cart";
import {Vue3Lottie} from "vue3-lottie";
import confettiData from '@/assets/animations/confetti.json';
import pricingService from '@/service/pricingService';

export default {
  name: 'Pricing',
  components: {
    PricingManagementModal,
    BillingManagementModal: PricingManagementModal,
    Vue3Lottie,
    PricingPacketModal,
    PackageManageModal,
    Layout
  },

  data() {
    return {
      quantities: {},
      products: [],
      cartStore: useCartStore(),
      showPricingModal: false,
      bannerUrgency: 'normal',
      isBillingModalOpen: false,
      showConfetti: false,
      confettiAnimation: confettiData,
      currentPlanData: null,
      packages: [],
      userPackageStatus: null,
      usageData: [],
      billingHistory: [],
      expandedInvoices: {}, // { invoiceUuid: bool } — kalemler expand/collapse
      billingSummary: null,
      paymentMethods: [],
      showPackageManageModal: false,
      isPackageManageLoading: false,
      aiCreditData: null,
      isLoading: false,
      isUsageLoading: false,
      isBillingLoading: false,
      error: null,
      usageError: null,
      billingError: null
    };
  },

  computed: {
    items() {
      return this.cartStore.items
    },

    translatedPackageName() {
      return this.currentPlanInfo?.packageName || this.$t('advanced_package');
    },

    primaryCard() {
      // paymentMethods bir array (loadBillingData'da response.data.data atanıyor),
      // bu yüzden direkt .find kullanılır. Eğer kart yoksa veya primary işaretli yoksa
      // ilk aktif kartı fallback olarak döndür.
      if (!Array.isArray(this.paymentMethods) || this.paymentMethods.length === 0) {
        return null;
      }
      return this.paymentMethods.find(card => card.isPrimary)
          || this.paymentMethods[0];
    },

    currentPlanInfo() {
      if (!this.currentPlanData) return null;

      const packageInfo = this.currentPlanData.package;
      const packageStatus = this.currentPlanData.packageStatus || this.userPackageStatus;
      const userLimits = this.extractUserLimits();

      // Demo durumunda packageStatus'tan paket adını al
      const isDemo = packageStatus?.isDemo === true || packageStatus?.type === 'demo' || packageInfo?.isDemo === true;
      const displayPackageName = isDemo
        ? (packageStatus?.packageName || 'Demo')
        : (packageInfo?.name ? `${packageInfo.name} Paket` : null);

      return {
        packageName: displayPackageName,
        totalUsers: userLimits.totalUsers,
        usedUsers: userLimits.usedUsers,
        remainingUsers: userLimits.remainingUsers,
        usagePercentage: userLimits.usagePercentage,
        statusMessage: this.getStatusMessage(packageInfo),
        canUpgrade: !isDemo,
        packageDescription: packageInfo?.shortDescription,
        urgency: packageStatus?.urgency,
        daysRemaining: packageStatus?.daysRemaining,
        isDemo: isDemo,
        endDateTime: packageStatus?.endDateTime,
        nextPaymentInfo: this.getNextPaymentInfo(packageStatus),
        nextInvoiceInfo: this.getNextInvoiceInfo(packageStatus),
        firstPaymentMessage: this.currentPlanData?.packageInfo?.messages?.first_payment,
        demoExpiryMessage: this.currentPlanData?.packageInfo?.messages?.demo_expiry,
        twoPaymentMessage: this.currentPlanData?.packageInfo?.messages?.next_billing,
      };
    },

    formattedRealUsageItems() {
      if (!this.usageData || !Array.isArray(this.usageData)) return [];

      // Web link'ler kullanım listesinde gösterilmez (mantığı "tıklama bütçesi per-link"
      // olduğundan kullanıcı için kafa karıştırıcı). Müşteri web link bilgisini
      // ayrı bir ekrandan görür ya da sadece /billing/addons'tan satın alır.
      const HIDDEN_PRODUCT_KEYS = ['web_link_share_limit', 'additional_web_link'];

      return this.usageData
        .filter(item => !HIDDEN_PRODUCT_KEYS.includes(item.productKey))
        // assignedLimit=0 olan ürünler "bu pakette yok" demek (ör. Başlangıç'ta mobile_user_limit, ai_agent_limit).
        // Kullanıcıya 0/0 göstermek anlamsız, bu satırları gizle.
        // 'unlimited' (string) durumu hep göster.
        .filter(item => item.assignedLimit === 'unlimited' || Number(item.assignedLimit) > 0)
        .map(item => {
          const isUnlimited = item.assignedLimit === 'unlimited';
          const usagePercentage = (!isUnlimited && Number(item.assignedLimit) > 0)
              ? Math.round((item.usedLimit / item.assignedLimit) * 100)
              : 0;

          return {
            productKey: item.productKey,
            displayName: item.displayName || item.name,
            // Backend `unit` döndürmüyor — limitType'tan çevir
            unit: this.translateLimitTypeUnit(item.limitType),
            assignedLimit: item.assignedLimit,
            usedLimit: item.usedLimit,
            remainingLimit: item.remainingLimit,
            usagePercentage,
            limitType: item.limitType,
            isUnlimited,
            isOverLimit: !isUnlimited && item.usedLimit > item.assignedLimit,
            isNearLimit: !isUnlimited && usagePercentage > 80
          };
        }).sort((a, b) => {
          // Önce kullanım yüzdesine göre azalan, eşitse productKey alfabetik
          const pctDiff = b.usagePercentage - a.usagePercentage;
          if (pctDiff !== 0) return pctDiff;
          return (a.productKey || '').localeCompare(b.productKey || '');
        });
    },

    formattedUsageData() {
      return pricingService.formatUsageData(this.usageData);
    },

    currentPackage() {
      if (!this.userPackageStatus || !this.packages.length) return null;
      return this.packages.find(pkg => pkg.packageId === this.userPackageStatus.currentPackageId);
    },

    aiCreditUsagePercentage() {
      if (!this.aiCreditData || !this.aiCreditData.total) return 0;
      return Math.round((this.aiCreditData.used / this.aiCreditData.total) * 100);
    },

    shouldShowUrgentBanner() {
      return ['warning', 'critical', 'expired', 'overdue'].includes(this.bannerUrgency);
    },

    enhancedUserPackageStatus() {
      const baseStatus = this.userPackageStatus || {};

      const currentPackageId = this.currentPlanData?.package?.packageId ||
          this.currentPlanData?.packageId ||
          null;

      return {
        ...baseStatus,
        currentPackageId: currentPackageId
      };
    },

    /**
     * PackageManageModal için zenginleştirilmiş paket bilgisi.
     * userPackageStatus + currentPlanData'dan alanlar birleştirilir.
     */
    packageManageData() {
      if (!this.userPackageStatus) return null;
      const plan = this.currentPlanData?.package || this.currentPlanData || {};
      return {
        packageName: this.userPackageStatus.packageName || plan.name,
        billingPeriod: this.userPackageStatus.billingPeriod || plan.billingPeriod,
        endDate: this.userPackageStatus.endDate || plan.endDate,
        daysRemaining: this.userPackageStatus.daysRemaining,
        autoRenew: this.userPackageStatus.autoRenew ?? plan.autoRenew ?? false,
        amount: this.userPackageStatus.amount,
        currency: this.userPackageStatus.currency || 'USD',
      };
    },
  },

  async created() {
    await this.loadAllData();
  },

  mounted() {
    this.$nextTick(() => {
      const element = document.querySelector('.confetti-overlay')
    })

    if (this.$route.query.confetti === 'true') {
      this.showSuccessConfetti()
    }
  },

  watch: {
    '$route'(to, from) {
      if (to.query.confetti === 'true') {
        this.showSuccessConfetti();
      }
    }
  },

  methods: {
    /**
     * Backend limitType (GB/minute/count/hour) → kullanıcı dostu birim
     */
    translateLimitTypeUnit(limitType) {
      const map = {
        GB: 'GB',
        MB: 'MB',
        minute: this.$t('unit_minute'),
        hour: this.$t('unit_hour') || 'saat',
        count: this.$t('unit_piece') || 'adet',
        isCheck: '',
      };
      return map[limitType] || '';
    },

    toggleInvoice(invoice) {
      const key = invoice.invoiceUuid || invoice.orderId;
      if (!key) return;
      this.expandedInvoices = {
        ...this.expandedInvoices,
        [key]: !this.expandedInvoices[key],
      };
    },

    formatTransactionDate(isoDate) {
      if (!isoDate) return '-';
      try {
        const d = new Date(isoDate);
        if (isNaN(d.getTime())) return isoDate;
        return d.toLocaleDateString(this.$i18n.locale === 'tr' ? 'tr-TR' : 'en-US', {
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit'
        });
      } catch (e) { return isoDate; }
    },

    async loadAllData() {
      try {
        this.isLoading = true;
        this.error = null;

        await Promise.all([
          this.loadCurrentPlan(),
          this.loadPricingData(),
          this.loadUsageData(),
          this.loadBillingData(),
          this.loadAiCreditData()
        ]);

      } catch (error) {
        this.error = this.$t('page_load_error');
      } finally {
        this.isLoading = false;
      }
    },

    async loadCurrentPlan(companyId = null) {
      try {
        const response = await pricingService.getCurrentPlan(companyId);

        if (response.data.responseType === 'success') {
          this.currentPlanData = response.data.data;
        } else {
          throw new Error(response.data.message || this.$t('plan_info_error'));
        }

      } catch (error) {
        this.currentPlanData = null;
      }
    },

    extractUserLimits() {
      if (this.usageData) {
        const userAddon = this.usageData.find(
            product => product.productKey === 'mobile_app_core'
        );

        if (userAddon) {
          const totalUsers = parseInt(userAddon.assignedLimit) || null;
          const usedUsers = parseInt(userAddon.usedLimit) || null;
          const remainingUsers = totalUsers && usedUsers ? Math.max(0, totalUsers - usedUsers) : null;
          const usagePercentage = totalUsers && usedUsers ? Math.round((usedUsers / totalUsers) * 100) : null;

          return {
            totalUsers,
            usedUsers,
            remainingUsers,
            usagePercentage
          };
        }
      }

      if (this.currentPlanData?.package?.description) {
        const description = this.currentPlanData.package.description;
        const userMatch = description.match(/(\d+)-(\d+)\s*.*kullanıcısı/i);

        if (userMatch && userMatch[2]) {
          const totalUsers = parseInt(userMatch[2]);
          return {
            totalUsers,
            usedUsers: null,
            remainingUsers: null,
            usagePercentage: null
          };
        }
      }

      return {
        totalUsers: null,
        usedUsers: null,
        remainingUsers: null,
        usagePercentage: null
      };
    },

    getStatusMessage(packageInfo) {
      if (!packageInfo) return null;

      const status = this.currentPlanData?.packageStatus || this.userPackageStatus;

      // Demo kontrolü - packageStatus.isDemo veya type === 'demo' veya packageInfo.isDemo
      const isDemo = status?.isDemo === true || status?.type === 'demo' || packageInfo?.isDemo === true;

      // Expired veya cancelled durumunda özel mesaj
      if (status?.status === 'expired' || status?.type === 'cancelled') {
        if (isDemo) {
          return this.$t('demo_expired_message');
        }
        return this.$t('package_expired_message');
      }

      if (isDemo) {
        // Demo paketi - ücretsiz yazısı göster
        if (status?.daysRemaining > 0 && status?.endDate) {
          return this.$t('free_trial_days_remaining', { days: status.daysRemaining });
        }
        return this.$t('free_trial_upgrade_message');
      }

      // Demo değil - ücretsiz yazısı YOK, sadece paket adı ve bitiş tarihi
      const endDate = this.calculatePackageEndDate();
      if (endDate) {
        return this.$t('package_valid_until', { name: packageInfo.name, date: endDate });
      }
      return this.$t('package_active', { name: packageInfo.name });
    },

    calculatePackageEndDate() {
      // API'den gelen bitiş tarihini kontrol et
      const endDateFromAPI = this.currentPlanData?.packageInfo?.endDate ||
                            this.currentPlanData?.endDate ||
                            this.currentPlanData?.subscriptionEndDate ||
                            this.currentPlanData?.package?.endDate;

      if (endDateFromAPI) {
        const endDate = new Date(endDateFromAPI);
        // Eğer tarih geçmişte değilse kullan
        if (endDate > new Date()) {
          return this.formatDateForDisplay(endDateFromAPI);
        }
      }

      // API'den geçerli tarih yoksa bugünden 1 yıl sonrasını hesapla
      const today = new Date();
      const endDate = new Date(today);
      endDate.setFullYear(endDate.getFullYear() + 1);
      return this.formatDateForDisplay(endDate);
    },

    getNextPaymentInfo(packageStatus) {
      if (packageStatus?.nextPaymentDate && packageStatus?.nextPaymentAmount) {
        return `${this.$t('your_first_payment')} ${packageStatus.nextPaymentDate} ${this.$t('in_history')} ${packageStatus.nextPaymentAmount} ${this.$t('will_be_collected_as')}.`;
      }
      return null;
    },

    getNextInvoiceInfo(packageStatus) {
      if (packageStatus?.nextInvoiceDate && packageStatus?.nextInvoiceAmount && packageStatus?.paymentDeadline) {
        return `${this.$t('your_next_invoice')} ${packageStatus.nextInvoiceDate} ${this.$t('in_history')} ${packageStatus.nextInvoiceAmount} ${this.$t('will_be_collected_as')}. ${this.$t('payment_deadline')} ${packageStatus.paymentDeadline}.`;
      }
      return null;
    },

    async loadPricingData() {
      try {
        this.error = null;

        // Tek istek ile hem packages hem packageStatus alınıyor (duplicate request fix)
        const packagesResponse = await pricingService.getPackages(this.bannerUrgency);

        if (packagesResponse.data.responseType === 'success') {
          this.packages = packagesResponse.data.data || [];

          // packageStatus aynı response'dan alınıyor
          if (packagesResponse.data.packageStatus) {
            this.userPackageStatus = packagesResponse.data.packageStatus;

            if (this.userPackageStatus?.urgency) {
              this.bannerUrgency = this.userPackageStatus.urgency;
            }
          }
        }

      } catch (error) {
        this.error = this.$t('pricing_load_error');

        this.packages = [];
        this.userPackageStatus = null;
      }
    },

    async loadUsageData() {
      try {
        this.isUsageLoading = true;
        this.usageError = null;

        const response = await pricingService.getUsageLimits();

        if (response.data.responseType === 'success') {
          this.usageData = response.data.data || [];
        }

        // AI Agent kullanımı dış servisten gelir (Node.js: ai.ibilityapp.com)
        // Backend usageData'sındaki ai_agent_limit usedLimit değerini override et.
        await this.overrideAiAgentUsage();

      } catch (error) {
        this.usageError = this.$t('usage_load_error');
      } finally {
        this.isUsageLoading = false;
      }
    },

    /**
     * AI Agent kullanım sayısını dış servisten alıp usageData'da override eder.
     * Şirket UUID'sini packageStatus veya storage'dan çıkarır.
     */
    async overrideAiAgentUsage() {
      const companyUuid = this.userPackageStatus?.companyUuid
        || this.currentPlanData?.company?.uuid
        || JSON.parse(localStorage.getItem('user') || '{}')?.companyUuid;

      if (!companyUuid) return;

      try {
        const agentCount = await aiAgentService.getAgentCount(companyUuid);
        const target = (this.usageData || []).find(item =>
          item.productKey === 'ai_agent_limit' || item.productKey === 'additional_ai_agent'
        );
        if (target) {
          target.usedLimit = agentCount;
          // remainingLimit'i de yeniden hesapla
          if (typeof target.assignedLimit === 'number') {
            target.remainingLimit = Math.max(0, target.assignedLimit - agentCount);
          }
        }
      } catch (e) {
        // Sessizce başarısız ol — backend default sayım kalır
      }
    },

    async loadAiCreditData() {
      const companyUuid = this.userPackageStatus?.companyUuid
        || this.currentPlanData?.company?.uuid
        || JSON.parse(localStorage.getItem('user') || '{}')?.companyUuid;

      if (!companyUuid) return;

      try {
        const response = await pricingService.getAiCreditLimit(companyUuid);
        if (response.data?.hasAccess !== undefined) {
          this.aiCreditData = response.data;
        } else if (response.data?.data) {
          this.aiCreditData = response.data.data;
        }
      } catch (e) {
        // AI credit erişimi yoksa sessizce geç
        this.aiCreditData = null;
      }
    },

    async loadBillingData() {
      try {
        this.isBillingLoading = true;
        this.billingError = null;

        // getBillingHistory aslında billing addresses dönüyordu (eski bug).
        // Yeni getPaymentHistory endpoint'i gerçek ödeme geçmişini döner.
        const [paymentHistoryResponse, paymentResponse] = await Promise.all([
          pricingService.getPaymentHistory(),
          pricingService.getPaymentMethods()
        ]);

        if (paymentHistoryResponse.data.responseType === 'success') {
          const data = paymentHistoryResponse.data.data || {};
          // Yeni response: invoices[] (faturaya gore gruplanmis, kalemler items icinde)
          // Geri uyum: eski history[] varsa onu da kabul et
          this.billingHistory = data.invoices || data.history || [];
          this.billingSummary = data.summary || null;
        }

        if (paymentResponse.data.responseType === 'success') {
          // Backend response paginated: { current_page, data: [...cards], links, ... }
          // İç array'i çıkarıp düz liste olarak tut.
          const paginatedData = paymentResponse.data.data;
          if (Array.isArray(paginatedData)) {
            this.paymentMethods = paginatedData;
          } else if (paginatedData && Array.isArray(paginatedData.data)) {
            this.paymentMethods = paginatedData.data;
          } else {
            this.paymentMethods = [];
          }
        }

      } catch (error) {
        this.billingError = this.$t('billing_load_error');
      } finally {
        this.isBillingLoading = false;
      }
    },

    async refreshData() {
      await this.loadAllData();
    },

    async openPricingModal() {
      if (!this.isLoading) {
        await this.loadPricingData();
      }
      this.showPricingModal = true;
    },

    /**
     * "Takip Et" butonu: önce modal'ı loading ile aç, sonra veriyi (yeniden) çek.
     * Böylece kullanıcı önce "paket yok" boş ekranını görmez.
     */
    async openPackageManageModal() {
      this.showPackageManageModal = true;
      // Eğer veri yoksa veya bayatlamış ihtimaliyle her zaman taze çek
      this.isPackageManageLoading = true;
      try {
        await this.loadPricingData();
      } finally {
        this.isPackageManageLoading = false;
      }
    },

    /**
     * "Öde" butonuna tıklanınca PricingPacketModal'ı aç.
     * Müşteri mevcut paketi seçer, payPackage akışı pending invoice'ı kapatır.
     */
    handlePayPending(row) {
      this.openPricingModal();
    },

    closePricingModal() {
      this.showPricingModal = false;
    },

    openBillingModal() {
      this.isBillingModalOpen = true;
    },

    closeBillingModal() {
      this.isBillingModalOpen = false;
    },

    showSuccessConfetti() {
      this.showConfetti = true
      this.$nextTick(() => {
        this.$router.replace('/billing')
      })
    },

    onConfettiComplete() {
      this.showConfetti = false
    },

    async onBillingUpdated(billingData) {

      try {
        await this.loadBillingData();

        this.$toast.success(this.$t('billing_updated_success'));

      } catch (error) {
        this.$toast.error(this.$t('update_error'));
      }
    },

    async onAddCard(cardData) {
      try {
        const response = await pricingService.addPaymentMethod(cardData);

        if (response.data.responseType === 'success') {
          await this.loadBillingData();
          this.$toast.success(this.$t('payment_method_added'));
        }

      } catch (error) {
        this.$toast.error(this.$t('payment_method_add_error'));
      }
    },

    async onDeleteCard(cardIndex) {
      try {
        const cardId = this.paymentMethods[cardIndex]?.id;

        if (!cardId) {
          throw new Error(this.$t('card_id_not_found'));
        }

        const response = await pricingService.deletePaymentMethod(cardId);

        if (response.data.responseType === 'success') {
          await this.loadBillingData();
          this.$toast.success(this.$t('payment_method_deleted'));
        }

      } catch (error) {
        this.$toast.error(this.$t('payment_method_delete_error'));
      }
    },

    async onPackageUpgraded() {
      this.showSuccessConfetti();

      await this.refreshData();

      this.closePricingModal();
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 0
      }).format(amount);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString('tr-TR');
    },

    formatDateForDisplay(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = d.getDate();
      const month = d.toLocaleString('tr-TR', { month: 'long' });
      const year = d.getFullYear();
      return `${day} ${month} ${year}`;
    },

    calculateUsagePercentage(current, limit) {
      if (!limit || limit === 0) return 0;
      return Math.min((current / limit) * 100, 100);
    },

    async onCardPrimaryChanged(data) {
      try {
        await this.loadBillingData();

      } catch (error) {
      }
    },

    getCardBrandName(brandCode) {
      const brandNames = {
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'amex': 'American Express',
        'jcb': 'JCB',
        'discover': 'Discover',
        'diners': 'Diners Club',
        'unionpay': 'Union Pay',
        'maestro': 'Maestro',
        'mir': 'Mir',
        'troy': 'Troy',
        'elo': 'Elo',
        'hipercard': 'Hipercard'
      }

      return brandNames[brandCode?.toLowerCase()] || brandCode || this.$t('credit_card')
    }
  }
}
</script>

<style scoped>
.confetti-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 999999 !important;
  background: rgba(0, 0, 0, 0.1) !important;
  pointer-events: none !important;
}

.confetti-overlay .lottie-container,
.confetti-overlay > div {
  max-width: 100vw;
  max-height: 100vh;
  width: 100%;
  height: 100%;
}

.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #98a2b3;
  font-family: 'euclid-regular', sans-serif;
}

.page-title {
  margin-bottom: 24px;
}

.billing-container {
  display: grid;
  grid-template-columns: 65% 35%;
  gap: 15px;
  width: 100%;
  align-items: start;
}

.left-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.current-plan-card,
.payment-method-card,
.transaction-history-card,
.usage-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 24px;
}

.current-plan-title {
  font-size: 14px;
  font-family: euclid_medium, 'sans-serif';
  margin-bottom: 20px !important;
  display: flex;
}

.plan-header {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 16px;
}

.plan-info-wrapper {
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: space-between;
  width: 100%;
}

.plan-info-wrapper h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.plan-info {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.plan-info span {
  color: #868c98;
  font-size: 13px;
}

.user-count {
  color: #6b7280;
  font-size: 14px;
}

.plan-details {
  margin-bottom: 20px;
}

.plan-details p {
  color: #4b5563;
  line-height: 1.5;
  margin: 0;
}

.plan-actions {
  display: flex;
  gap: 12px;
}

.btn-primary {
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 12px;
  font-weight: 500;
  cursor: pointer;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-secondary {
  background: white;
  color: #1a1a1a;
  border: 1px solid #d1d5db;
  padding: 10px 20px;
  border-radius: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  align-items: center;
}

.payment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.payment-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.btn-outline {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 6px 12px;
  border-radius: 10px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  height: 24px;
  align-items: center;
  justify-content: center;
}

.payment-info {
  margin-bottom: 16px;
}

.card-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-direction: row;
  justify-content: space-between;
}

.card-wrapper {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.card-details {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.card-brand {
  font-size: 16px;
  color: #101728;
  font-family: 'euclid_medium', sans-serif;
}

.card-number {
  color: #98a2b3;
  font-size: 12px;
  font-family: 'euclid_medium', sans-serif;
}

.expiry {
  font-size: 14px;
  color: #6b7280;
}

.next-payment {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #f3f4f6;
  border-radius: 8px;
  font-size: 14px;
  color: #4b5563;
}

.transaction-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.transaction-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.transaction-table {
  border-radius: 8px;
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: 1.3fr 0.9fr 1.8fr 0.9fr 0.9fr 0.9fr;
  padding: 12px 16px;
  background: #f9fafb;
  font-weight: 500;
  color: #6b7280;
  font-size: 13px;
  border-bottom: 1px solid #e5e7eb;
}

.table-rows {
  display: flex;
  flex-direction: column;
}

.table-row {
  display: grid;
  grid-template-columns: 1.3fr 0.9fr 1.8fr 0.9fr 0.9fr 0.9fr;
  padding: 14px 16px;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
  color: #344054;
  align-items: center;
}

.table-row:last-child { border-bottom: none; }
.table-row:hover { background: #fafbfc; }

.row-date { color: #667085; font-family: euclid_regular, sans-serif; }
.row-description { color: #101828; font-family: euclid_medium, sans-serif; }
.row-amount { color: #101828; font-family: euclid_semi_bold, sans-serif; }

.type-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-family: euclid_medium, sans-serif;
}
.type-package { background: #ECFDF3; color: #027A48; }
.type-addon { background: #EFF8FF; color: #175CD3; }

.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-family: euclid_medium, sans-serif;
}
.status-paid { background: #ECFDF3; color: #027A48; }
.status-pending { background: #FEF0C7; color: #B54708; }
.status-cancelled { background: #FEE4E2; color: #B42318; }

.pay-now-btn {
  padding: 4px 12px;
  background: #DC6803;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  font-family: euclid_medium, sans-serif;
  cursor: pointer;
}
.pay-now-btn:hover { background: #B54708; }

.row-invoice { font-size: 12px; }
.invoice-link {
  color: #4A68F8;
  text-decoration: none;
  font-family: euclid_medium, sans-serif;
}
.invoice-link:hover { text-decoration: underline; }
.invoice-pending { color: #98A2B3; font-family: euclid_regular, sans-serif; }
.invoice-number {
  color: #344054;
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
}

/* Fatura grupli liste — expand/collapse */
.invoice-row { transition: background 0.15s; }
.invoice-row.is-expandable { cursor: pointer; }
.invoice-row.is-expandable:hover { background: #fafafa; }
.invoice-row.expanded { background: #f9fafb; border-bottom-color: transparent; }
.expand-icon { display: inline-block; margin-right: 6px; color: #6b7280; font-size: 11px; width: 12px; }

.try-equivalent {
  display: block;
  font-size: 11px;
  color: #6b7280;
  font-family: euclid_regular, sans-serif;
  margin-top: 2px;
}

.invoice-items {
  background: #f9fafb;
  border-top: 1px dashed #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 8px 16px 12px 40px;
}
.invoice-line-item {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px dashed #e5e7eb;
  font-size: 13px;
}
.invoice-line-item:last-of-type { border-bottom: none; }
.item-description { color: #344054; }
.item-amount { color: #344054; text-align: right; font-family: euclid_medium, sans-serif; }
.item-amount .try-equivalent { font-family: euclid_regular, sans-serif; }

.invoice-totals {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}
.invoice-total-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 13px;
  color: #6b7280;
}
.invoice-total-row.total {
  color: #111827;
  font-size: 14px;
  border-top: 1px solid #e5e7eb;
  margin-top: 4px;
  padding-top: 8px;
}
.invoice-total-row .try-equivalent { text-align: right; }
.invoice-rate-note {
  margin-top: 8px;
  font-size: 11px;
  color: #98A2B3;
  font-style: italic;
}

.billing-note {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding: 12px;
  background: #f3f4f6;
  border-radius: 8px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.4;
  align-items: center;
}

.right-section {
  position: sticky;
  top: 24px;
  height: fit-content;
  width: 100%;
}

.usage-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.usage-card h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.addon-link {
  font-size: 12px;
  color: #4A68F8;
  font-family: euclid_regular, sans-serif;
  cursor: pointer;
}

.usage-item {
  margin-bottom: 20px;
}

.usage-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.usage-label {
  font-weight: 500;
  color: #1a1a1a;
  font-size: 14px;
}

.usage-count {
  font-size: 12px;
  color: #6b7280;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #f2f4f7;
  border-radius: 4px;
  overflow: hidden;
  border: none;
}

.progress-fill {
  height: 100%;
  background: #3da33e;
  transition: width 0.3s ease;
}

.btn-manage {
  width: 100%;
  background: white;
  color: #1a1a1a;
  border: 1px solid #d1d5db;
  padding: 12px;
  border-radius: 12px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 20px;
  height: 32px;
  justify-content: center;
  align-items: center;
  display: flex;
}

@media (max-width: 1024px) {
  .billing-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .right-section {
    position: static;
  }
}

@media (max-width: 768px) {
  .billing-container {
    padding: 0 16px;
  }

  .current-plan-card,
  .payment-method-card,
  .transaction-history-card,
  .usage-card {
    padding: 16px;
  }

  .plan-actions {
    flex-direction: column;
  }
}

.progress-success {
  background: #10b981 !important;
}

.progress-warning {
  background: #f59e0b !important;
}

.progress-danger {
  background: #ef4444 !important;
}

.usage-danger {
  color: #ef4444 !important;
  font-weight: 500;
}

.usage-error {
  text-align: center;
  padding: 20px;
  color: #6b7280;
}

.btn-retry {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  margin-top: 8px;
  cursor: pointer;
}

.usage-empty {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
  font-style: italic;
}

/* AI Credit Card */
.ai-credit-card {
  margin-top: 16px;
}

.ai-credit-summary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ai-credit-main {
  margin-bottom: 4px;
}

.ai-credit-breakdown,
.ai-credit-agents {
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
}

.ai-credit-breakdown-title {
  display: block;
  font-size: 12px;
  font-family: euclid_medium, sans-serif;
  color: #667085;
  margin-bottom: 8px;
}

.ai-credit-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 13px;
  color: #344054;
  font-family: euclid_regular, sans-serif;
}

.skeleton-loading {
  background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

</style>
